module.exports = __webpack_public_path__ + "static/media/Silder8.80f1e791.webp";